import { render } from "./Area.vue?vue&type=template&id=09e1d098"
import script from "./Area.vue?vue&type=script&lang=js"
export * from "./Area.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "09e1d098"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09e1d098', script)) {
    api.reload('09e1d098', script)
  }
  
  module.hot.accept("./Area.vue?vue&type=template&id=09e1d098", () => {
    api.rerender('09e1d098', render)
  })

}

script.__file = "resources/js/Pages/User/Area.vue"

export default script